import { render, staticRenderFns } from "./PokerTablePage.vue?vue&type=template&id=9586d122&scoped=true&"
import script from "./PokerTablePage.vue?vue&type=script&lang=js&"
export * from "./PokerTablePage.vue?vue&type=script&lang=js&"
import style0 from "./PokerTablePage.vue?vue&type=style&index=0&id=9586d122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9586d122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
